import React from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaUser, FaClock, FaChevronLeft, FaShare, FaLinkedin, FaTwitter, FaFacebook } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DetailBlog10 = () => {
    const blogPost = {
        id: 1,
        title: "Recouvrement de vos créances : le guide pratique de votre Expert-Comptable",
        excerpt: "Une facture émise est une promesse de revenus. Découvrez les procédures OHADA pour recouvrer efficacement vos créances commerciales et protéger votre trésorerie.",
        content: `
      <p class="lead">Une facture émise est une promesse de revenus. Mais lorsque cette promesse n'est pas tenue, la trésorerie de votre entreprise est la première victime. Les factures impayées ne sont pas une fatalité ; elles représentent des créances que vous avez le droit de recouvrer.</p>
      
      <p>À CINEF-EXPERTISE COMPTABLE, nous savons que chaque franc compte pour votre croissance. Ce guide pratique vous aide à comprendre et maîtriser le recouvrement de vos créances commerciales, en conformité avec l'Acte Uniforme portant Organisation des Procédures Simplifiées de Recouvrement et des Voies d'Exécution (AUPSRVE) de l'OHADA.</p>
      
      <h3>1. Les fondements de votre Action : Les Conditions de la Créance</h3>
      <p>Avant même d'invoquer l'Acte Uniforme, votre créance doit être juridiquement irréprochable. Elle doit être, conformément à l'article 2 de l'AUPSRVE :</p>
      
      <ul>
        <li><strong>Certaine :</strong> Son existence ne doit souffrir d'aucune contestation sérieuse. La preuve (contrat, facture validée, bon de livraison signé) doit être tangible.</li>
        <li><strong>Liquide :</strong> Son montant doit être chiffré précisément.</li>
        <li><strong>Exigible :</strong> Son terme doit être échu.</li>
      </ul>
      
      <p>Si ces trois conditions sont réunies et que votre créance n'est pas prescrite, la voie judiciaire simplifiée vous est ouverte. Cependant, la phase amiable demeure une étape obligatoire avant tout recours judiciaire.</p>
      
      <h3>2. La Phase amiable : L'approche stratégique à privilégier</h3>
      <p>Avant d'envisager une action en justice, la voie amiable est toujours la première étape. Elle est moins coûteuse, plus rapide et permet de préserver vos relations commerciales.</p>
      
      <h4>Les étapes de la phase amiable :</h4>
      <ul>
        <li><strong>Les Relances Simples :</strong> Commencez par des contacts informels (appel téléphonique, e-mail) pour comprendre la raison du retard. Il peut s'agir d'un simple oubli.</li>
        <li><strong>La Lettre de Relance :</strong> Si les premiers contacts échouent, envoyez un courrier formel rappelant les détails de la facture impayée (numéro, date, montant) et demandant une régularisation rapide.</li>
        <li><strong>La Lettre de Mise en Demeure :</strong> C'est l'ultime étape de la phase amiable. Ce courrier, envoyé en recommandé avec accusé de réception ou signifié par un huissier de justice, a une réelle valeur juridique. Il somme officiellement le débiteur de payer dans un délai précis (souvent 8 jours), faute de quoi une procédure judiciaire sera engagée.</li>
      </ul>
      
      <h3>3. L'Injonction de payer OHADA : Votre voie rapide vers le recouvrement</h3>
      <p>L'injonction de payer est une procédure rapide et peu coûteuse, conçue pour les créances civiles et commerciales dont le recouvrement est certain. L'article 2 de l'AUPSRVE stipule que cette procédure ne peut être engagée que si la créance a une cause contractuelle ou résulte de l'émission, l'endossement, l'aval ou l'acceptation de tout effet de commerce ou de l'émission d'un chèque.</p>
      
      <h4>Étape 1 : La Requête introductive d'instance</h4>
      <p>La procédure est initiée par une requête déposée auprès de la juridiction compétente du domicile du débiteur. Conformément à l'article 4 de l'AUPSRVE, cette requête doit contenir des informations précises (identité des parties, décompte exact des sommes) et être accompagnée de toutes les pièces justificatives.</p>
      
      <div class="conseil-box">
        <strong>Le conseil de l'expert :</strong> La qualité de votre dossier à ce stade est déterminante. Un dossier complet et bien organisé maximise vos chances d'obtenir une décision favorable.
      </div>
      
      <h4>Étape 2 : L'Ordonnance d'Injonction de Payer</h4>
      <p>Le juge examine votre requête sur la base des seuls documents fournis (article 5).</p>
      <ul>
        <li>S'il estime votre demande fondée, il rend une "ordonnance portant injonction de payer" pour tout ou partie de la somme (article 6).</li>
        <li>S'il estime la demande non fondée, il rend une décision de rejet. Cette décision n'est pas susceptible de recours.</li>
      </ul>
      
      <h4>Étape 3 : La signification de l'ordonnance</h4>
      <p>Une fois l'ordonnance obtenue, vous devez la faire signifier (remettre officiellement) à votre débiteur par un huissier de justice dans un délai de trois (3) mois, comme l'exige l'article 7. <strong>Attention</strong>, si ce délai est dépassé, l'ordonnance est caduque.</p>
      
      <h4>Étape 4 : L'opposition par le débiteur</h4>
      <p>À compter de la signification, votre débiteur dispose de quinze (15) jours pour faire opposition à l'ordonnance auprès de la juridiction qui l'a rendue (article 10). L'opposition a pour effet de transformer la procédure simplifiée en un procès classique devant la juridiction.</p>
      
      <h4>Étape 5 : L'apposition de la formule exécutoire</h4>
      <p>Si le débiteur ne fait pas opposition dans le délai de 15 jours, vous pouvez demander au greffe de la juridiction d'apposer la "formule exécutoire" sur votre ordonnance (article 16). Ce document devient alors un titre exécutoire, un ordre de justice puissant qui vous ouvre les "voies d'exécution".</p>
      
      <h3>4. Les voies d'exécution : de la décision au paiement effectif</h3>
      <p>Obtenir un titre exécutoire est une chose, être payé en est une autre. L'Acte Uniforme (AUPSRVE) organise les moyens de contraindre votre débiteur à s'exécuter (article 28). Armé de votre titre, un huissier peut mettre en œuvre plusieurs types de saisies :</p>
      
      <ul>
        <li><strong>La Saisie-Attribution des créances (articles 153 à 168) :</strong> C'est la plus efficace. Elle permet de saisir directement les sommes d'argent qui vous sont dues sur les comptes bancaires de votre débiteur.</li>
        <li><strong>La Saisie-Vente des biens meubles Corporels (articles 91 à 140) :</strong> Elle consiste à saisir les biens matériels de votre débiteur (véhicules, matériel, stock...) en vue de les vendre aux enchères pour vous payer sur le prix de vente.</li>
        <li><strong>La Saisie des rémunérations (articles 173 à 186) :</strong> Il est également possible de saisir une partie du salaire de votre débiteur s'il s'agit d'une personne physique.</li>
      </ul>
      
      <blockquote>
        "Ne laissez pas les impayés dicter la santé de votre trésorerie. L'Acte Uniforme OHADA est un outil puissant, à condition de l'utiliser avec méthode et rigueur."
      </blockquote>
      
      <h3>Notre Mission d'Expert-Comptable : Sécuriser votre Chiffre d'Affaires</h3>
      <p>La maîtrise de ces procédures est essentielle. Le rôle de votre expert-comptable est de vous intégrer dans cette démarche bien avant que le litige ne survienne.</p>
      
      <ul>
        <li><strong>En Amont :</strong> Nous structurons vos documents commerciaux (CGV, factures, contrats) pour qu'ils constituent des preuves irréfutables.</li>
        <li><strong>Pendant la Procédure :</strong> Nous préparons et certifions les décomptes financiers et les pièces comptables nécessaires à la constitution d'un dossier de requête solide pour vos conseils juridiques.</li>
        <li><strong>En Aval :</strong> Nous vous aidons à évaluer l'impact des créances irrécouvrables et à mettre en place les provisions nécessaires pour protéger la sincérité de vos comptes.</li>
      </ul>
      
      <h5>Faites appel à un expert-comptable pour un audit de votre poste clients et pour mettre en place une stratégie de recouvrement qui protège activement vos intérêts.</h5>
      
      <div class="ressources-box">
        <h4>Pour Aller plus loin :</h4>
        <ul>
          <li>Site officiel de l'OHADA : <a href="http://www.ohada.org" target="_blank">www.ohada.org</a></li>
          <li>Jurisprudence et documentation : <a href="http://www.ohada.com" target="_blank">www.ohada.com</a></li>
          <li>Site de l'Ordre des Experts-comptables : <a href="https://oeccabenin.bj/" target="_blank">oeccabenin.bj</a></li>
        </ul>
      </div>
    `,
        categories: ["Juridique", "Recouvrement", "OHADA"],
        tags: ["Créances", "Recouvrement", "OHADA", "Injonction de payer", "Expert-comptable", "Trésorerie"],
        date: "13 Octobre 2025",
        author: "Expert CINEF-EC",
        authorTitle: "Expert-Comptable et Conseil Juridique",
        readTime: "10 min",
        featured: true
    };

    const similarBlogs = [
        {
            id: 2,
            title: "Les nouvelles dispositions OHADA pour les PME en 2025",
            image: "/assets/images/image7.png",
            date: "1 octobre 2025",
            category: "Juridique"
        },
        {
            id: 3,
            title: "Optimiser la gestion de votre trésorerie : les bonnes pratiques",
            image: "/assets/images/image8.png",
            date: "25 septembre 2025",
            category: "Finance"
        }
    ];

    return (
        <>
            <Header />

            <div className="blog-content py-5">
                <div className="container">
                    <nav className="breadcrumb-container mb-4">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/" className="text-decoration-none">Accueil</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/actualites/blog" className="text-decoration-none">Blog</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                {blogPost.title}
                            </li>
                        </ol>
                    </nav>

                    <div className="row">
                        <div className="col-lg-8">
                            <div className="blog-header mb-4">
                                <div className="categories-badges mb-3">
                                    {blogPost.categories.map((category, index) => (
                                        <span key={index} className="category-badge me-2">{category}</span>
                                    ))}
                                </div>
                                <h1 className="blog-title">{blogPost.title}</h1>

                                <div className="blog-meta d-flex align-items-center mt-3">
                                    <div className="meta-item d-flex align-items-center">
                                        <FaCalendarAlt className="meta-icon" />
                                        <span>{blogPost.date}</span>
                                    </div>
                                    <div className="meta-item d-flex align-items-center">
                                        <FaUser className="meta-icon" />
                                        <span>{blogPost.author}</span>
                                    </div>
                                    <div className="meta-item d-flex align-items-center">
                                        <FaClock className="meta-icon" />
                                        <span>{blogPost.readTime} de lecture</span>
                                    </div>
                                </div>
                            </div>

                            <div className="blog-excerpt mb-4">
                                <p className="lead">{blogPost.excerpt}</p>
                            </div>

                            <div className="blog-body mb-5" dangerouslySetInnerHTML={{ __html: blogPost.content }} />

                            <div className="blog-tags mb-4">
                                {blogPost.tags.map((tag, index) => (
                                    <Link key={index} to={``} className="blog-tag">
                                        #{tag}
                                    </Link>
                                ))}
                            </div>

                            <div className="blog-share mb-5">
                                <h5 className="share-title">Partager cet article</h5>
                                <div className="social-buttons">
                                    <a href="#" className="social-button linkedin">
                                        <FaLinkedin />
                                    </a>
                                    <a href="#" className="social-button twitter">
                                        <FaTwitter />
                                    </a>
                                    <a href="#" className="social-button facebook">
                                        <FaFacebook />
                                    </a>
                                </div>
                            </div>

                            <div className="blog-actions mb-5">
                                <Link to="/actualites/blog" className="btn btn-back">
                                    <FaChevronLeft className="me-2" /> Retour au blog
                                </Link>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="sidebar-widget author-widget">
                                <h4 className="widget-title">À propos de l'auteur</h4>
                                <div className="author-profile">
                                    {/* <div className="author-image">
                                        <img src="../assets/images/image5.png" alt={blogPost.author} className="img-fluid rounded-circle" />
                                    </div> */}
                                    <div className="author-info">
                                        <h5 className="author-name">{blogPost.author}</h5>
                                        <p className="author-title">{blogPost.authorTitle}</p>
                                        <p className="author-bio">Expert en droit OHADA et procédures de recouvrement, spécialisé dans l'accompagnement des entreprises béninoises pour la sécurisation de leur trésorerie et la gestion des créances.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="sidebar-widget similar-blogs-widget">
                                <h4 className="widget-title">Articles similaires</h4>
                                <div className="similar-blogs">
                                    {similarBlogs.map((similarBlog) => (
                                        <Link key={similarBlog.id} to={`/blog/${similarBlog.id}`} className="similar-blog">
                                            <div className="similar-blog-image">
                                                <img src={similarBlog.image} alt={similarBlog.title} className="img-fluid rounded" />
                                                <span className="category-badge small">{similarBlog.category}</span>
                                            </div>
                                            <div className="similar-blog-content">
                                                <h5 className="similar-blog-title">{similarBlog.title}</h5>
                                                <div className="similar-blog-date">
                                                    <FaCalendarAlt className="me-1" size={12} />
                                                    <small>{similarBlog.date}</small>
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>

                            <div className="sidebar-widget newsletter-widget">
                                <h4 className="widget-title">Newsletter</h4>
                                <p className="newsletter-desc">Recevez nos conseils sur le recouvrement de créances et la gestion juridique directement dans votre boîte mail</p>
                                <form className="newsletter-form">
                                    <div className="form-group mb-3">
                                        <input type="email" className="form-control" placeholder="Votre adresse email" required />
                                    </div>
                                    <button type="submit" className="btn btn-primary w-100">S'abonner</button>
                                </form>
                            </div>

                            <div className="sidebar-widget categories-widget">
                                <h4 className="widget-title">Ressources OHADA</h4>
                                <ul className="categories-list">
                                    <li><a href="https://www.ohada.org" target="_blank" rel="noopener noreferrer">Site officiel OHADA <span>→</span></a></li>
                                    <li><a href="https://www.ohada.com" target="_blank" rel="noopener noreferrer">Jurisprudence OHADA <span>→</span></a></li>
                                    <li><a href="https://oeccabenin.bj/" target="_blank" rel="noopener noreferrer">Ordre des Experts-Comptables <span>→</span></a></li>
                                    <li><Link to="/services/comptabilite-fiscalite">Nos services <span>→</span></Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

            <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

        * {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .blog-content {
          background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
          min-height: 100vh;
        }

        .breadcrumb {
          background: transparent;
          padding: 0;
          margin: 0;
          font-size: 0.875rem;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          color: #9ca3af;
          content: "›";
          font-size: 1.2rem;
        }

        .breadcrumb-item a {
          color: #6b7280;
          text-decoration: none;
          transition: color 0.2s ease;
          font-weight: 500;
        }

        .breadcrumb-item a:hover {
          color: #dc2626;
        }

        .breadcrumb-item.active {
          color: #1f2937;
          font-weight: 600;
        }

        .blog-header {
          margin-bottom: 2.5rem;
        }

        .categories-badges {
          margin-bottom: 1rem;
        }

        .category-badge {
          display: inline-block;
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          color: white;
          padding: 0.375rem 1rem;
          border-radius: 20px;
          font-size: 0.813rem;
          font-weight: 600;
          letter-spacing: 0.3px;
          box-shadow: 0 2px 8px rgba(220, 38, 38, 0.15);
        }

        .blog-title {
          font-size: 2.75rem;
          font-weight: 800;
          line-height: 1.15;
          color: #111827;
          margin-bottom: 1.5rem;
          letter-spacing: -0.02em;
        }

        .blog-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 1.5rem;
          padding: 1rem 0;
          border-top: 1px solid #e5e7eb;
          border-bottom: 1px solid #e5e7eb;
        }

        .meta-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #6b7280;
          font-size: 0.875rem;
          font-weight: 500;
        }

        .meta-icon {
          color: #dc2626;
          font-size: 1rem;
        }

        .blog-excerpt {
          background: linear-gradient(135deg, #fef2f2 0%, #f0fdf4 100%);
          border-left: 4px solid #dc2626;
          padding: 1.75rem;
          border-radius: 8px;
          margin-bottom: 2.5rem;
        }

        .blog-excerpt .lead {
          font-size: 1.125rem;
          font-weight: 500;
          line-height: 1.75;
          color: #374151;
          margin: 0;
          text-align: justify;
        }

        .blog-body {
          font-size: 1.0625rem;
          line-height: 1.8;
          color: #374151;
          text-align: justify;
        }

        .blog-body p {
          margin-bottom: 1.5rem;
        }

        .blog-body h3 {
          font-size: 1.875rem;
          font-weight: 700;
          color: #111827;
          margin-top: 3rem;
          margin-bottom: 1.25rem;
          position: relative;
          padding-left: 1rem;
          border-left: 4px solid #dc2626;
        }

        .blog-body h4 {
          font-size: 1.375rem;
          font-weight: 600;
          color: #1f2937;
          margin-top: 2rem;
          margin-bottom: 1rem;
        }

        .blog-body h5 {
          font-size: 1.125rem;
          font-weight: 600;
          color: #16a34a;
          margin-top: 1.5rem;
          margin-bottom: 1rem;
          padding: 1.25rem;
          background: linear-gradient(135deg, #fef2f2 0%, #f0fdf4 100%);
          border-radius: 8px;
          border-left: 3px solid #16a34a;
          text-align: center;
        }

        .blog-body ul,
        .blog-body ol {
          margin: 1.5rem 0;
          padding-left: 0;
          list-style: none;
        }

        .blog-body li {
          position: relative;
          padding-left: 2rem;
          margin-bottom: 1rem;
          line-height: 1.7;
        }

        .blog-body ul li::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0.6rem;
          width: 8px;
          height: 8px;
          background: linear-gradient(135deg, #dc2626, #16a34a);
          border-radius: 50%;
        }

        .blog-body strong {
          color: #111827;
          font-weight: 700;
        }

        .blog-body blockquote {
          background: linear-gradient(135deg, #fef2f2 0%, #f0fdf4 100%);
          border-left: 4px solid #16a34a;
          padding: 2rem;
          margin: 2.5rem 0;
          border-radius: 8px;
          font-size: 1.25rem;
          font-weight: 500;
          font-style: italic;
          color: #1f2937;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
        }

        .conseil-box,
        .ressources-box {
          background: linear-gradient(135deg, #fef2f2 0%, #fffbeb 100%);
          border: 2px solid #fbbf24;
          border-radius: 12px;
          padding: 1.75rem;
          margin: 2rem 0;
          box-shadow: 0 4px 15px rgba(251, 191, 36, 0.1);
        }

        .conseil-box strong {
          color: #dc2626;
          font-size: 1.125rem;
          display: block;
          margin-bottom: 0.75rem;
        }

        .ressources-box h4 {
          color: #16a34a;
          font-size: 1.25rem;
          font-weight: 700;
          margin: 0 0 1rem 0;
          padding: 0;
          border: none;
        }

        .ressources-box ul {
          margin: 0;
        }

        .ressources-box li {
          margin-bottom: 0.75rem;
        }

        .ressources-box a {
          color: #dc2626;
          text-decoration: none;
          font-weight: 600;
          transition: color 0.3s ease;
        }

        .ressources-box a:hover {
          color: #16a34a;
          text-decoration: underline;
        }

        .blog-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
          padding: 1.5rem 0;
          border-top: 1px solid #e5e7eb;
        }

        .blog-tag {
          background: #f3f4f6;
          color: #4b5563;
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.875rem;
          font-weight: 500;
          text-decoration: none;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border: 1px solid transparent;
        }

        .blog-tag:hover {
          background: linear-gradient(135deg, #dc2626, #16a34a);
          color: white;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(220, 38, 38, 0.2);
        }

        .blog-share {
          padding: 2rem 0;
          border-top: 1px solid #e5e7eb;
          margin-top: 2rem;
        }

        .share-title {
          font-size: 1rem;
          font-weight: 600;
          color: #374151;
          margin-bottom: 1rem;
        }

        .social-buttons {
          display: flex;
          gap: 1rem;
        }

        .social-button {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .social-button:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        }

        .linkedin { background: #0077B5; }
        .twitter { background: #1DA1F2; }
        .facebook { background: #4267B2; }

        .btn-back {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: white;
          color: #374151;
          padding: 0.875rem 1.75rem;
          border-radius: 30px;
          text-decoration: none;
          font-weight: 600;
          font-size: 0.938rem;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
          border: 1px solid #e5e7eb;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .btn-back:hover {
          background: #dc2626;
          color: white;
          transform: translateX(-4px);
          box-shadow: 0 4px 16px rgba(220, 38, 38, 0.2);
        }

        .sidebar-widget {
          background: white;
          border-radius: 12px;
          padding: 1.5rem;
            margin-bottom: 2.5rem;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
        }

        .widget-title {
            font-size: 1.25rem;
            font-weight: 700;
            color: #111827;
            margin-bottom: 1.5rem;
            border-bottom: 2px solid #e5e7eb;
            padding-bottom: 0.5rem;
        }
        .author-widget .author-profile {
            display: flex;
            align-items: center;
            gap: 1.5rem;
        }
        .author-image img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            border-radius: 50%;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
        .author-name {
            font-size: 1.125rem;
            font-weight: 700;
            color: #111827;
            margin: 0;
        }
        .author-title {
            font-size: 0.875rem;
            color: #6b7280;
            margin: 0.25rem 0;
        }
        .author-bio {
            font-size: 0.875rem;
            color: #4b5563;
            line-height: 1.6;
        }
        .similar-blogs .similar-blog {
            display: flex;
            gap: 1rem;
            margin-bottom: 1.5rem;
            text-decoration: none;
            color: inherit;
            transition: background 0.3s ease;
            padding: 0.5rem;
            border-radius: 8px;
        }
        .similar-blogs .similar-blog:hover {
            background: #f9fafb;
        }
        .similar-blog-image {
            position: relative;
            width: 80px;
            height: 80px;
            flex-shrink: 0;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
        .similar-blog-image img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .similar-blog-image .category-badge.small {
            position: absolute;
            top: 8px;
            left: 8px;
            font-size: 0.688rem;
            padding: 0.25rem 0.75rem;
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(220, 38, 38, 0.15);
        }
        .similar-blog-content {
            flex: 1;
        }
        .similar-blog-title {
            font-size: 1rem;
            font-weight: 600;
            color: #111827;
            margin: 0 0 0.5rem 0;
            line-height: 1.4;
        }
        .similar-blog-date {
            display: flex;
            align-items: center;
            gap: 0.25rem;
            font-size: 0.813rem;
            color: #6b7280;
        }
        .newsletter-widget .newsletter-desc {
            font-size: 0.875rem;
            color: #4b5563;
            margin-bottom: 1rem;
            line-height: 1.6;
        }
        .newsletter-form .form-control {
            border-radius: 8px;
            border: 1px solid #d1d5db;
            padding: 0.75rem 1rem;
            font-size: 0.938rem;
            transition: border-color 0.3s ease;
        }
        .newsletter-form .form-control:focus {
            border-color: #dc2626;
            box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2);
            outline: none;
        }
        .newsletter-form .btn {
            background: #dc2626;
            color: white;
            font-weight: 600;
            border-radius: 8px;
            padding: 0.75rem;
            font-size: 1rem;
            transition: background 0.3s ease;
            border: none;
        }
        .newsletter-form .btn:hover {
            background: #b91c1c;
        }
        .categories-widget .categories-list {
            list-style: none;
            padding: 0;
            margin: 0;
        }
        .categories-widget .categories-list li {    
            margin-bottom: 1rem;
        }
        .categories-widget .categories-list li a {
            color: #374151;
            text-decoration: none;
            font-weight: 500;
            font-size: 0.938rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            transition: color 0.3s ease;
        }
        .categories-widget .categories-list li a:hover {
            color: #dc2626;
            text-decoration: underline;
        }

        @media (max-width: 991.98px) {
            .blog-title {
                font-size: 2.25rem;
            }
        }
        @media (max-width: 767.98px) {
            .blog-title {
                font-size: 1.875rem;
            }
            .blog-meta {
                flex-direction: column;
                gap: 0.75rem;
            }
            .author-widget .author-profile {
                flex-direction: column;
                text-align: center;
            }
            .author-image img {
                width: 100px;
                height: 100px;
                margin-bottom: 0.75rem;
            }
        }
        `}</style>
        </>
    );
};
export default DetailBlog10;